<div *ngIf="!hideFullPageContent">
  <div class="innerpage-fullwithbanner" *ngIf="property.Id == null || property.Id == 0">
    <h2 class="bighead">Document Access <span class="offerstatus">{{rowCount|number}}</span></h2>
    <ul class="bread-crumbs">
      <li><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
      <li *ngIf="currentMenu!=''"><span>{{currentMenu}}<span style="padding:8px;">|</span></span></li>
      <li>Document Access</li>
    </ul>
  </div>
  <div class="floatinghead clearfix d-flex" *ngIf="property.Id > 0">
    <h2 class="mainhead">
      <span class="text">Document Download / Request List</span>
    </h2>
    <!--- Add user button-->
    <button type="button" *ngIf="propertyIds!=null&&propertyIds!=0&&(caApproval||omapproval||dueDiligenceApproval||ddCaApproval)" class="btn btn-success btn-lg ml-auto" (click)="OpenAddUserSlider(addUsers, 'panlestyle','OM')">Add User</button>
  </div>

  <!--<div class="d-flex margin0" *ngIf="(authService.Broker()||authService.Admin())&& property.Id > 0">
    <label class="custom-checkbox margin-right-15" for="checkbox14">
      <input [(ngModel)]="omapproval" (change)="saveOMApproval(omapproval)" type="checkbox">Offering Memorandum requires approval
      <i></i>
    </label>
    <label class="custom-checkbox margin-right-15" for="checkbox14">
      <input [(ngModel)]="dueDiligenceApproval" (change)="saveDueDiligenceApproval(dueDiligenceApproval)" type="checkbox">Due Diligence requires approval
      <i></i>
    </label>
    <label class="custom-checkbox margin-right-15" for="checkbox14">
      <input [(ngModel)]="caApproval" (change)="saveCAApproval(caApproval)" type="checkbox">Confidentiality Agreement requires approval
      <i></i>
    </label>
  </div>-->
  <div [ngClass]="{'featuredproperties section-margin': (property.Id == null || property.Id == 0), 'featuredproperties':property.Id > 0}" class="margin-top-20">
    <div class="container table-fixed container-lg min-heightcontainer">

      <div [ngClass]="{'border-div margin0': (property.Id == null || property.Id == 0), 'margin0':property.Id > 0}">
        <div class="row" *ngIf="(authService.Broker()||authService.Admin()||authService.SuperAdmin())&& property.Id > 0">
          <div class="col-md-12 d-flex align-items-center margin-bottom-15 ">
            <div class="om-dd-check-wrapperd-flex d-flex flex-wrap-wrap">
              <div style="display: inline-block; flex: 0" class="inline-block">
                <ul class="statuslisting list-filter-02 doc-listing  margin-bottom-0  agreement-box">
                  <li class="transition margin-bottom-10" style="min-height: 1px;">
                    <div class="list-filter-div">
                      <div class="inner-div d-flex flex-wrap-wrap">
                        <label class="margin-right-10">
                          Offering Memorandum:
                        </label>
                        <div class="d-flex">
                          <label class="custom-checkbox margin-right-15 margin-bottom-0 whitespacenowrap" for="checkbox14">
                            <input [(ngModel)]="omapproval" (change)="saveOMApproval(omapproval)" type="checkbox">Requires Approval
                            <i></i>
                          </label>
                          <label class="custom-checkbox margin-bottom-0 whitespacenowrap" for="checkbox14" style="margin-right:0">
                            <input [(ngModel)]="caApproval" (change)="saveCAApproval(caApproval,1)" type="checkbox">Requires Confidentiality Agreement
                            <i></i>
                          </label>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div style="display:inline-block;flex:0" class="inline-block  margin-right-10">
                <ul class="statuslisting list-filter-02 doc-listing  margin-bottom-0  agreement-box">
                  <li class="transition" style="margin-right:0 !important;min-height:1px;">
                    <div class="list-filter-div">
                      <div class="inner-div d-flex flex-wrap-wrap">
                        <label class="margin-right-10">
                          Due Diligence:
                        </label>
                        <div class="d-flex">
                          <label class="custom-checkbox margin-right-15 margin-bottom-0 whitespacenowrap" for="checkbox14">
                            <input [(ngModel)]="dueDiligenceApproval" (change)="saveDueDiligenceApproval(dueDiligenceApproval)" type="checkbox">Requires Approval
                            <i></i>
                          </label>
                          <label class="custom-checkbox margin-bottom-0 whitespacenowrap" for="checkbox14" style="margin-right:0 !important">
                            <input [(ngModel)]="ddCaApproval" (change)="saveCAApproval(ddCaApproval,2)" type="checkbox">Requires Confidentiality Agreement
                            <i></i>
                          </label>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          
          </div>
        </div>
        <div class="cf">
          <div class="margin0">
            <div class="form-group doc-access-filter">
              <div class="row">
                <div class="col-lg-9">
                  <div class="d-flex align-items-center doc-listing-wrap">
                    <div *ngIf="property.OfferMemoReqApproval || property.Id == 0" style="display:inline-block;" class="inline-block">

                      <ul class="statuslisting list-filter-02 doc-listing  margin-bottom-0">
                        <li class="transition">
                          <label class="form-label">
                            <span class="total">{{OMPending + OMAccepted + OMRejected + OmInvited}} </span> OM Request
                            <!--<a class="filter btn  btn-circle btn-adduser btn-green adduserbtn ml-auto" *ngIf="IsAccessPermitted==true&&propertyIds!=null&&propertyIds!=0" href="javascript:void(0);" placement="left" tooltip="Add User to OM" (click)="OpenAddUserSlider(addUsers, 'panlestyle','OM')"><i class="fa fa-user-plus" aria-hidden="true"></i></a>-->
                          </label>
                          <div class="list-filter-div">
                            <div class="inner-div">
                              <a href="javascript:void(0);" (click)="filterByStatus(1,501)" [class.active]="activeOMfilterButton === status.Pending">
                                <h3 style="color:#e47220">{{OMPending}} </h3>
                                <h4 style="color:black">Pending</h4>

                              </a>
                              <a href="javascript:void(0);" (click)="filterByStatus(1,502)" [class.active]="activeOMfilterButton === status.Accepted">
                                <h3 style="color:#28a436">{{OMAccepted}} </h3>
                                <h4 style="color:black">Accepted</h4>
                              </a>
                              <a href="javascript:void(0);" (click)="filterByStatus(1,503)" [class.active]="activeOMfilterButton === status.Rejected">

                                <h3 style="color:#fb4338">{{OMRejected}} </h3>
                                <h4 style="color:black">Rejected</h4>
                              </a>
                              <a href="javascript:void(0);" (click)="filterByStatus(1,505)" [class.active]="activeOMfilterButton === status.Invited">

                                <h3 style="color:#fb4338">{{OmInvited}}</h3>
                                <h4 style="color:black">Invited</h4>
                              </a>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div *ngIf="property.DueDiligenceReqApproval || property.Id == 0" style="display:inline-block;" class="inline-block">
                      <ul class="statuslisting list-filter-02 doc-listing  margin-bottom-0">
                        <li class="transition">
                          <label class="form-label">
                            <span class="total">{{DDPending + DDAccepted + DDRejected +Invited}}</span> DD Request
                            <!--<a class="filter btn  btn-circle btn-adduser btn-green adduserbtn ml-auto" *ngIf="IsAccessPermitted==true&&propertyIds!=null&&propertyIds!=0" href="javascript:void(0);" placement="left" tooltip="Add User to DD" (click)="OpenAddUserSlider(addUsers, 'panlestyle','DueDiligence')"><i class="fa fa-user-plus" aria-hidden="true"></i></a>-->
                          </label>

                          <div class="list-filter-div">
                            <div class="inner-div">
                              <a href="javascript:void(0);" (click)="filterByStatus(2,501)" [class.active]="activeDDfilterButton === status.Pending">
                                <h3 style="color:#e47220">{{DDPending}}</h3>
                                <h4 style="color:black">Pending</h4>

                              </a>
                              <a href="javascript:void(0);" (click)="filterByStatus(2,502)" [class.active]="activeDDfilterButton === status.Accepted">
                                <h3 style="color:#28a436">{{DDAccepted}}</h3>
                                <h4 style="color:black">Accepted</h4>
                              </a>
                              <a href="javascript:void(0);" (click)="filterByStatus(2,503)" [class.active]="activeDDfilterButton === status.Rejected">

                                <h3 style="color:#fb4338">{{DDRejected}}</h3>
                                <h4 style="color:black">Rejected</h4>
                              </a>
                              <a href="javascript:void(0);" (click)="filterByStatus(2,505)" [class.active]="activeDDfilterButton === status.Invited">

                                <h3 style="color:#fb4338">{{Invited}}</h3>
                                <h4 style="color:black">Invited</h4>
                              </a>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div style="display:inline-block;" class="inline-block">

                      <ul class="statuslisting list-filter-02 doc-listing  margin-bottom-0">
                        <li class="transition">
                          <label class="form-label"><span class="total">{{OMDownloaded + DDDownloaded}} </span> Downloads </label>
                          <div class="list-filter-div">

                            <div class="inner-div">
                              <a href="javascript:void(0);" (click)="filterByOMDownloaded()" [class.active]="activeDownloadedfilterButton === 1">
                                <h3 style="color:#e47220">{{OMDownloaded}} </h3>
                                <h4 style="color:black">OM</h4>

                              </a>
                              <a href="javascript:void(0);" (click)="filterByDDDownloaded()" [class.active]="activeDownloadedfilterButton === 2">
                                <h3 style="color:#28a436">{{DDDownloaded}} </h3>
                                <h4 style="color:black">DD</h4>
                              </a>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <a class="bluelinkunderline no-underline margin-right-10" href="javascript:void(0);" (click)="filterByStatus(3,0)" style="position:relative;left:6px">View All</a>
                   

                    <!--<a class="filter btn  btn-circle btn-adduser btn-green adduserbtn" *ngIf="!property.DueDiligenceReqApproval&&IsAccessPermitted==true&&propertyIds!=null&&propertyIds!=0" href="javascript:void(0);" placement="left" tooltip="Add User to DD" (click)="OpenAddUserSlider(addUsers, 'panlestyle')">
    <i class="fa fa-user-plus" aria-hidden="true"></i>
    <sup class="duedilegencecount btn-circle ml-auto" *ngIf="(DDAccepted + Invited) > 0">{{(DDAccepted + Invited) > 99 ? '99+':(DDAccepted + Invited)}}</sup>
  </a>-->
                  </div>


                </div>
                <div class="col-lg-3">
                  <div class="floatinghead clearfix">
                    <div class="rightside clearfix pull-right search-xl" style="width:auto;">
                      <label class="form-label margin-bottom-10">&nbsp;</label>
                      <div class="search-sec">
                        <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search">
                        <i class="fa fa-search icon" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>

            <!--<h2 class="mainhead "><span class="text">Document Access Requests</span></h2>-->


            <div class="table-responsive">
              <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
                <thead>
                  <tr>
                    <th class="hide">Id</th>
                    <th class="sticky-left z-100" data-orderable="false">Actions</th>
                    <th>Prospect</th>
                    <th>Role</th>
                    <th style="width:150px" [hidden]="property.Id != 0">Tenant</th>
                    <th [hidden]="!property.OfferMemoReqApproval && property.Id > 0">OM Request Date</th>
                    <th [hidden]="!property.OfferMemoReqApproval && property.Id > 0">OM Download Request</th>
                    <th>OM Downloaded</th>
                    <!--<th>CA</th>-->
                    <th [hidden]="!property.DueDiligenceReqApproval && property.Id > 0">DD Request Date</th>
                    <th [hidden]="!property.DueDiligenceReqApproval && property.Id > 0">DD Download Request</th>
                    <th>DD Downloaded</th>
                    <th data-orderable="false">CA</th>
                    <th class="hide">OM Modified By</th>
                    <th class="hide">DD Modified By</th>

                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of docAccess ;let i = index">
                    <td class="hide">{{item.DARId}}</td>
                    <td>
                      <div class="d-flex">
                        <!--Removed to fix:#340054 bug-->
                        <!--<div class="btn-group" dropdown *ngIf="((item.OfferMemoReqApproval && (item.RequestForOfferAccess == 'Pending' || item.RequestForOfferAccess == 'Rejected' || item.RequestForOfferAccess == 'Accepted'))|| (item.DueDiligenceReqApproval && (item.RequestForDueDiligenceAccess == 'Pending' || item.RequestForDueDiligenceAccess == 'Rejected' || item.RequestForDueDiligenceAccess == 'Accepted')))">
                          <button [ngClass]="{'disable-link':property.IsDeleted}" id="button-basic" dropdownToggle type="button" class="blueone dropdown-toggle" tooltip="Action"
                                  aria-controls="dropdown-basic" placement="right">
                            <i class="fa fa-cog" aria-hidden="true"></i>
                          </button>
                          <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu z-index-99 leftaligned-dropdown"
                              role="menu" aria-labelledby="button-basic">
                            <li *ngIf="this.Validation.hasAccess('DocumentAccess', 'AcceptOM') && (item.RequestForOfferAccess == 'Pending' || item.RequestForOfferAccess == 'Rejected')"><a class="dropdown-item" href="javascript:void(0);" (click)="onActionClick('OM', status.Accepted, item)">Accept OM Download Request</a></li>
                            <li *ngIf="this.Validation.hasAccess('DocumentAccess', 'RejectOM') && (item.RequestForOfferAccess == 'Pending' || item.RequestForOfferAccess == 'Accepted')"><a class="dropdown-item" href="javascript:void(0);" (click)="onActionClick('OM', status.Rejected, item)">Reject OM Download Request</a></li>
                            <li *ngIf="this.Validation.hasAccess('DocumentAccess', 'AcceptDD') && (item.RequestForDueDiligenceAccess == 'Pending' || item.RequestForDueDiligenceAccess == 'Rejected')"><a class="dropdown-item" href="javascript:void(0);" (click)="onActionClick('DD', status.Accepted, item)">Accept DD Download Request</a></li>
                            <li *ngIf="this.Validation.hasAccess('DocumentAccess', 'RejectDD') && (item.RequestForDueDiligenceAccess == 'Pending' || item.RequestForDueDiligenceAccess == 'Accepted')"><a class="dropdown-item" href="javascript:void(0);" (click)="onActionClick('DD', status.Rejected, item)">Reject DD Download Request</a></li>
                          </ul>
                        </div>-->
                        <div class="btn-group rightdropdown" *ngIf="checkEditAccess(item)&&(authService.Broker()||authService.Admin()||authService.SuperAdmin())">
                          <a href="javascript:void(0);" class="blueone" tooltip="Edit" placement="top" container="body" (click)="OpenAddConfidentialityAgreement(addConfidentialiTyAgreement, 'panlestyle',item)">
                            <i class="fa fa-cog" aria-hidden="true"></i>
                          </a>
                        </div>
                      </div>


                    </td>
                    <td>
                      <p><a href="javascript:void(0);" *ngIf="IsAdmin" routerLink="/registered-user-details/" [queryParams]="{principal:item.PrincipalGuid, prevroute:'Document Access', link : 'docaccesslist?fromMenu=Opportunity'}">{{ item.PrincipalName }} </a></p>
                      <p *ngIf="!IsAdmin" style="font-weight:600">{{ item.PrincipalName}}</p>
                      <p *ngIf="item.Phone" class="whitespacenowrap">{{ item.Phone | phone }}</p>
                      <p *ngIf="item.Email" class="whitespacenowrap">{{item.Email}}</p>

                    </td>
                    <td>{{item.UserRole!='Registration Pending'?item.UserRole:'-'}}</td>
                    <td style="width:150px" [hidden]="property.Id != 0"><p><a href="javascript:void(0);" routerLink="/viewproperty/{{item.Slug ? item.Slug :item.PropertyGuid}}" [queryParams]="{prevroute:'Document Access Request List',link:router.url}">{{item.PropertyName}}</a></p></td>
                    <td [hidden]="!property.OfferMemoReqApproval && property.Id > 0"><span>{{item.OfferAccessRequestDate ? (convertUTCDateToLocalDateOffer(item.OfferAccessRequestDate)| date:'MM/dd/yyyy') : '-'}}</span></td>
                    <td [hidden]="!property.OfferMemoReqApproval && property.Id > 0">
                      <p [ngClass]="{'greentextlabel':item.RequestForOfferAccess === 'Accepted',
                                           'redtextlabel':item.RequestForOfferAccess === 'Rejected',
                                           'orangetextlabel':item.RequestForOfferAccess === 'Pending'}" *ngIf="(item.UserRole!='Registration Pending'||(item.UserRole=='Registration Pending'&&item.RequestForOfferAccess!='Accepted'))">{{item.RequestForOfferAccess != 'New' ? item.RequestForOfferAccess!=null ? item.RequestForOfferAccess:'-' : '-' }}</p>
                      <p [ngClass]="{'not-available':item.RequestForOfferAccess === 'Accepted',
                                           'redtextlabel':item.RequestForOfferAccess === 'Rejected',
                                           'orangetextlabel':item.RequestForOfferAccess === 'Pending'}" *ngIf="item.UserRole=='Registration Pending'&&item.RequestForOfferAccess === 'Accepted'">Invited</p>

                      <p class="member-name">
                        <i class="fa fa-user-circle-o" aria-hidden="true" *ngIf="item.OfferAccessModifiedByN && item.RequestForOfferAccess != 'New'"></i> {{item.OfferAccessModifiedByN != '' ?  item.OfferAccessModifiedByN : ' ' }}
                      </p>
                    </td>
                    <td><span>{{item.OfferDownloadedDate ? (convertUTCDateToLocalDateOffer(item.OfferDownloadedDate)| date:'MM/dd/yyyy  hh:mm a') : '-'}}</span></td>


                    <td [hidden]="!property.DueDiligenceReqApproval && property.Id > 0"><span>{{item.DueDiligenceRequestDate ? (convertUTCDateToLocalDateDue(item.DueDiligenceRequestDate)| date:'MM/dd/yyyy'):'-'}}</span></td>
                    <td [hidden]="!property.DueDiligenceReqApproval && property.Id > 0">
                      <p [ngClass]="{'greentextlabel':item.RequestForDueDiligenceAccess === 'Accepted',
                                           'redtextlabel':item.RequestForDueDiligenceAccess === 'Rejected',
                                           'orangetextlabel':item.RequestForDueDiligenceAccess === 'Pending'}" *ngIf="(item.UserRole!='Registration Pending'||(item.UserRole=='Registration Pending'&&item.RequestForDueDiligenceAccess!='Accepted'))">{{item.RequestForDueDiligenceAccess != 'New' ? item.RequestForDueDiligenceAccess!=null ? item.RequestForDueDiligenceAccess:'-'  : '-'}}</p>
                      <p [ngClass]="{'not-available':item.RequestForDueDiligenceAccess === 'Accepted',
                                           'redtextlabel':item.RequestForDueDiligenceAccess === 'Rejected',
                                           'orangetextlabel':item.RequestForDueDiligenceAccess === 'Pending'}" *ngIf="item.UserRole=='Registration Pending'&&item.RequestForDueDiligenceAccess === 'Accepted'">Invited</p>

                      <p class="member-name">
                        <i class="fa fa-user-circle-o" aria-hidden="true" *ngIf="item.DueDiligenceModifiedByN && item.RequestForDueDiligenceAccess != 'New'"></i> {{item.DueDiligenceModifiedByN != '' ?  item.DueDiligenceModifiedByN : ' ' }}
                      </p>

                    </td>
                    <td><span>{{item.DueDiligenceDownloadedDate ? (convertUTCDateToLocalDateOffer(item.DueDiligenceDownloadedDate)| date:'MM/dd/yyyy  hh:mm a') : '-'}}</span></td>

                    <td>
                      <div *ngIf="(item.RequestForDueDiligenceAccess != 'New' || item.RequestForOfferAccess != 'New') && item.CADocumentPath">
                        <a triggers="hover" class="border-link" href={{item.CADocumentPath}} download="Document.pdf" target="_blank"  ng-reflect-tooltip="{{item.FileDisplayName ? item.FileDisplayName : 'Download'}}" container="body" placement="left" tooltip="{{item.FileDisplayName ? item.FileDisplayName : 'Download'}}">
                          <i aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>CA
                        </a>
                      </div>
                    </td>

                  </tr>
                </tbody>
                <tfoot>
                  <tr *ngIf="docAccess?.length == 0&&!IsLoading ">
                    <td colspan="15" class="odd no-data-available">
                      <div class="nodata">
                        <i class="fa fa-exclamation-triangle icon"></i>
                        <p>No Data Available</p>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="nodata" *ngIf="hideFullPageContent">
  <i class="fa fa- icon"></i>
  <p>No Access</p>
</div>
<ng-template #addUsers>
  <app-add-user-to-dd [modalRef]="modalRef" [PropertyId]="propertyIds" [OMRequireApproval]="omapproval" [DDRequireApproval]="dueDiligenceApproval" [Type]="sourceType" [IsAgreementRequired]="IsAgreementRequired" [propertyGuid]="propertyGuid"></app-add-user-to-dd>
</ng-template>
<ng-template #addConfidentialiTyAgreement>
  <app-add-confidentiality-Agreement [modalRef]="modalRef" [currentDocAccessRequest]="currentDocumentAccessRequest" [OMApproval]="omapproval" [DDApproval]="dueDiligenceApproval" [CAApproval]="IsAgreementRequired" [IsFromDetails]="IsFromDetailsPage " [propertyGuid]="propertyGuid"></app-add-confidentiality-Agreement>
</ng-template>
